module.exports = __webpack_public_path__ + "static/media/store_icon.d4a8259e.png";